import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const RiderRepository = RepositoryFactory.get('rider')

class RiderService {
  static async getRiders (params) {
    try {
      return await RiderRepository.getRiders(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getRider (riderId, params) {
    try {
      return await RiderRepository.getRider(CredentialsService.getCurrentTenantId(), riderId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateRider (riderId, data) {
    try {
      return await RiderRepository.updateRider(CredentialsService.getCurrentTenantId(), riderId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async createRider (data) {
    try {
      return await RiderRepository.createRider(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }

  /* static async getHistoryAssignments (riderId, params) {
    try {
      return await RiderRepository.getHistoryAssignments(riderId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getHistoryLesson (riderId, params) {
    try {
      return await RiderRepository.getHistoryLesson(riderId, params)
    } catch (error) {
      console.log(error)
    }
  } */
}

export default RiderService
